'use client'

import { REGEXP_ONLY_DIGITS } from 'input-otp'

import {
  InputOTP,
  InputOTPGroup,
  InputOTPSlot,
} from '@ui/components/shadcn/ui/input-otp'

import { BaseFieldProps, FieldShell } from './FieldShell'

const OTP_LENGTH = 6

export function OtpField({
  label = 'Verification code',
  ...shell
}: Omit<BaseFieldProps, 'label'> & { label?: BaseFieldProps['label'] }) {
  return (
    <FieldShell<string> label={label} labelClassName="justify-center" {...shell}>
      {({ field, controlProps }) => (
        <InputOTP
          {...controlProps}
          containerClassName="justify-center"
          maxLength={OTP_LENGTH}
          pattern={REGEXP_ONLY_DIGITS}
          autoComplete="one-time-code"
          value={field.state.value}
          onChange={(value) => field.handleChange(value)}
          onComplete={() => void field.form.handleSubmit()}
        >
          <InputOTPGroup>
            {Array.from({ length: OTP_LENGTH }, (_, index) => (
              <InputOTPSlot
                key={index}
                index={index}
                className="h-12 w-12 text-lg"
              />
            ))}
          </InputOTPGroup>
        </InputOTP>
      )}
    </FieldShell>
  )
}
